import { type CSSProperties, useCallback } from 'react';

export const useGetEventTitleStyle = () =>
  useCallback(
    ({ titleRows }: { titleRows: number }): CSSProperties | undefined =>
      titleRows > 1
        ? {
            lineClamp: titleRows,
            // eslint-disable-next-line @typescript-eslint/naming-convention -- CSS property name
            WebkitLineClamp: titleRows,
          }
        : undefined,
    [],
  );
